import { render, staticRenderFns } from "./AlumnoCertificado.vue?vue&type=template&id=3a71bce8&scoped=true"
import script from "./AlumnoCertificado.vue?vue&type=script&lang=js"
export * from "./AlumnoCertificado.vue?vue&type=script&lang=js"
import style0 from "./AlumnoCertificado.vue?vue&type=style&index=0&id=3a71bce8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a71bce8",
  null
  
)

export default component.exports